import React from 'react';
import { MbmProvider } from '@amzn/react-arb-tools';
import { LocalizationContextBuilder } from '@amzn/arb-tools';
import { DEFAULT_LOCALE } from '../constants';
import SherlockDashboard from './SherlockDashboard';
import arbManifest from 'translations/arbManifest';
import { resolveBundleUrlWithFallbacks } from '../helpers';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

const mbmOptions = {
    arbManifest,
    defaultLocalizationContext: new LocalizationContextBuilder()
        .withLocale(DEFAULT_LOCALE)
        .withDefaultLocale(DEFAULT_LOCALE)
        .build(),
    resolveBundleUrl: (
        resourcePackPath: string | undefined,
        locale: string,
        bundle: string
    ) => resolveBundleUrlWithFallbacks(resourcePackPath, locale, bundle),
};

const App = () => {
    return (
        <MbmProvider {...mbmOptions}>
            <BrowserRouter>
                <Routes>
                    {/* Root → /home */}
                    <Route path="/" element={<Navigate to="/home" replace />} />
                    {/* Use the same dashboard component for both routes */}
                    <Route path="/home" element={<SherlockDashboard />} />
                    <Route path="/tracker" element={<SherlockDashboard />} />
                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/home" replace />} />
                </Routes>
            </BrowserRouter>
        </MbmProvider>
    );
};

export default App;
